import {
  Button,
  FormFieldSet,
  PageTitle,
  ProgressTabAdv,
} from "../../../../../../../components";
import { useState } from "react";

const PaymentCheckout = ({ onBack, onContinue, tabs }) => {
  const dummyData = {
    "Total Cost": 1230000,
    "Total Items": 12,
    Billed: "yearly",
  };

  const selectedItems = [
    { name: "ATS", price: 578000, credits: 5 },
    { name: "ATS", price: 578000, credits: 5 },
  ];

  const additionalServices = [
    { label: "Contact Finder", value: "contact" },
    { label: "Digital Templates", value: "digital" },
    { label: "Email Cleanup", value: "email" },
    { label: "Job Grabber", value: "job" },
  ];

  const [AdditionBox, setAdditionBox] = useState([]);
  const [checkbox, setCheckbox] = useState([]);
  const [wfCheckBox, setWfCheckBox] = useState([]);
  const [selectedServices, setSelectedServices] = useState(
    additionalServices.reduce((acc, service) => {
      acc[service.value] = false;
      return acc;
    }, {})
  );
  return (
    <div className="p-5 flex flex-col flex-1 overflow-hidden">
      <div className="my-2">
        <Button
          title="Checkout"
          color="black"
          variant="text"
          size="lg"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-lg font-medium !px-2"
          onClick={onBack}
        />
      </div>

      <div className="mt-6 mb-3">
        <ProgressTabAdv tabs={tabs} />
      </div>
      <div className="flex flex-1 gap-8 items-center">
        {["ATS", "Workforce"].map((title) => (
          <div key={title} className="flex items-center gap-3">
            <FormFieldSet
              type="checkbox"
              noTitle
              values={title === "ATS" ? checkbox : wfCheckBox}
              options={[{ label: "", value: "1" }]}
              onChange={(values) =>
                title === "ATS" ? setCheckbox(values) : setWfCheckBox(values)
              }
              multiple
            />
            <span>{title}</span>
          </div>
        ))}

        <span className="px-2 py-2 rounded bg-primary-50 text-md font-normal mt-1 mb-2">
          Professional Plan
        </span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
        <div className="col-span-1">
          <div className="border border-gray-100 shadow-md px-4 py-4 flex flex-col space-y-4">
            <PageTitle title={"User Licenses"} tag="h6" />

            {/* ATS License */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
              <div className="flex-1">
                <span className="font-medium">ATS Licenses(23200/User)</span>
                <p className="text-sm mt-1">
                  Choose how many users you access
                  <span className="text-primary-500 ml-1 block md:block lg:inline">
                    ATS License
                  </span>
                </p>
              </div>
              <FormFieldSet
                className="w-full max-w-[120px]"
                type="text"
                title="Quantity"
                placeholder="5"
              />
            </div>

            {/* Workforce License */}
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2">
              <div className="flex-1">
                <span className="font-medium">
                  Workforce Licenses(23200/User)
                </span>
                <p className="text-sm mt-1">
                  Choose how many users you access
                  <span className="text-primary-500 ml-1 block md:block lg:inline">
                    Workforce License
                  </span>
                </p>
              </div>
              <FormFieldSet
                className="w-full max-w-[120px]"
                type="text"
                title="Quantity"
                placeholder="5"
              />
            </div>
          </div>

          <div className="mt-2">
            <div className="lg:col-span-1 col-span-2 border border-gray-200 p-4 shadow-md rounded">
              <PageTitle title={"Additional Services"} tag="h6" />

              {additionalServices.map((service) => (
                <>
                  <div
                    key={service.value}
                    className="grid grid-cols-2 xl:grid-cols-4 items-center py-3"
                  >
                    <div className="col-span-2">
                      <FormFieldSet
                        type="checkbox"
                        noTitle
                        multiple
                        labelPosition="after"
                        values={AdditionBox}
                        onChange={(vals) => {
                          setAdditionBox(vals);

                          const updated = { ...selectedServices };
                          additionalServices.forEach((s) => {
                            updated[s.value] = vals.includes(s.value);
                          });
                          setSelectedServices(updated);
                        }}
                        options={[
                          { label: service.label, value: service.value },
                        ]}
                      />
                    </div>

                    <div className="col-span-2 grid grid-cols-2 gap-2">
                      <FormFieldSet
                        type="select"
                        title="Quantity"
                        placeholder="Select"
                        disabled={!selectedServices[service.value]}
                      />

                      <FormFieldSet
                        type="text"
                        title="Units"
                        placeholder="Units"
                        disabled={!selectedServices[service.value]}
                      />
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <FormFieldSet
                      type="checkbox"
                      noTitle
                      labelPosition="after"
                      disabled={true}
                      // disabled={!selectedServices[service.value]}
                      options={[
                        { label: "Renew", value: `${service.value}-renew` },
                      ]}
                    />
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
        <div className="col-span-1">
          <div className="border border-gray-100 shadow-md flex flex-col ">
            <div className="flex ">
              <div className="space-y-2 mb-8 w-fit">
                {Object.entries(dummyData).map(([key, value], index) => (
                  <div
                    key={index}
                    className="body-two grid grid-cols-[2fr_2fr_2fr] items-center px-4 py-1 mt-2"
                  >
                    <span className="font-medium">{key}</span>

                    <span className="text-center">:</span>

                    <span className=" font-normal">{value || "—"}</span>
                  </div>
                ))}
              </div>
            </div>
            <hr className="w-[98%] text-gray-300 m-auto" />
            <div className="grid md:grid-cols-[repeat(2,1fr)] lg:grid-cols-1 md:pr-2">
            {selectedItems.map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center shadow-md bg-primary-50 px-2 py-2 ml-2 lg:w-[95%] xl:w-[70%] rounded-md my-2"
              >
                <div>
                  <h6>{item.name}</h6>
                  <span className="text-sm lg:text-md">
                    {item.price} /user | {item.credits} credit(s)
                  </span>
                </div>
                <Button icon={"delete"} type="icon" variant="text" color="black" className="hover:bg-primary-50 hover:text-primary-400"/>
              </div>
            ))}
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-10 2xl:mt-48">
            <Button title="Cancel" variant="outlined" onClick={onBack} />
            <Button title={"Checkout"} onClick={onContinue} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PaymentCheckout;
